export const API_ROUTE =
  process.env.REACT_APP_ENV === "DEVELOPMENT"
    ? process.env.REACT_APP_API_DEV_ROUTE
    : process.env.REACT_APP_API_PROD_ROUTE;
